export default {
  notification: {
    notifications: "Notifications",
    notificationsSubTitle: "View and customize notification settings.",
    notifications_settings: "Notification Settings",
    categories: {
      general: "general",
      devices: "devices",
      employees: "users",
      departments: "autopilot",
      applications: "applications",
      profiles: "profiles",
    },
  },
  organization: "Organization",
  organizationDescription: `Organization settings allow admins to update company information, including office locations, policies, time zones, and related organizational details.`,
  display: "Display",
  displayTitleDescription: "The logo is shown in emails & on different pages.",
  termAndCondition: "Terms & Condition",
  termAndConditionDescription: "Essential policies for your staff to follow.",
  deleteTermAndCondition: "Delete policies link?",
  directLink: "Link",
  fileSizeIsNotValid: "File size is not valid",
  fileShouldNotBeMoreThan2Mb: "File shouldn’t be more than 2MB",
  deleteLogo: "Delete Logo",
  deleteLogoConfirmation: "Are you sure you want to delete logo ?",
  cancel: "Cancel",
  delete: "Delete",
  upload: "upload",
  close: "Close",
  configure: "Configure",
  logoDeleted: "Logo has been removed",
  success: "Success",
  addedSuccessfully: "Added successfully",
  editedSuccessfully: "Edited successfully",
  add: "Add",
  update: "Update",
  officeInformation: "Office Information",
  edit: "Edit",
  officeName: "Office name",
  country: "Country",
  primaryPhoneNumber: "Phone number",
  invalidPhone: "Phone is invalid",
  email: "Email address",
  state: "State",
  city: "City",
  address: "Address",
  postalCode: "Post Code",
  setAsMainOffice: "Set as main office.",
  confirm: "Confirm",
  offices: "Offices",
  useWhenBuyingDevices: "Use when buying devices & accessories",
  addOffice: "Add office",
  areYouSureYouWantToDelete:
    "Deleting this information removes Trio's access to the office address. Are you sure you want to proceed?",
  officeDeleted: "Office successfully deleted",
  headquarter: "Headquarters",
  phoneNumber: "Phone number",
  inputOfficessAddressAllOverTheWorld: `Include a URL link to the MDM or IT policy users accept when enrolling (optional).`,
  invalidUrl: "The Url is invalid",
  linkGoesHere: "Your link goes here",
  URLlink: "URL link",
  policyLink: "Policy Link",
  save: "Save",
  complete: "Complete",
  back: "Back",
  termAndConditionUpdated: `Terms and conditions successfully updated`,
  mdmSetup: "MDM setup",
  apnSetup: "APN",
  setupApnSetup: "Setting up APNs for your company",
  apnSetupDescription1: `Set up Apple MDM to unlock additional services across your
  organization such as remote lock or erase. You can’t enroll devices
  until you upload your MDM push certificate.`,
  downloadCSRFile: "Download CSR file",
  apnSetupDescription2: `We’ve created a secure CSR file for you. This file is required to generate an Apple Push Certificate.`,
  downloadCSR: "Download CSR File",
  apnTitle1: "Get your Push Certificate from Apple",
  apnSetupDescription3: `Go to the Apple Push Certificates Portal, sign in with your Apple ID, and upload the CSR file. After that, download the generated certificate.`,
  signInToApplePortal: "Sign in to Apple Push Notification service",
  apnTitle2: "Upload your Push Certificate",
  apnSetupDescription4: `To complete your connection setup, upload the certificate that you downloaded from Apple.`,
  depSetup: "DEP",
  depTitle1: "Setting up DEP for your company",
  depDescription1: `Set up the Server DEP (Device Enrollment Program) for zero-touch enrollment. Upon activation of your DEP token, your new devices will be auto-enrolled into Trio using the customized activation mode you’ve set up.`,
  downloadTrioToken: "Download Server Token Request (Public Key)",
  depDescription2: `This file is used to create a secure connection between Apple and your MDM server.`,
  depTitle2: "Get your signed token from Apple Business Manager",
  depDescription3: `Then, log in to your Apple Business Manager and upload the Trio token for your organization.`,
  signInAppleBusinessPortal: `Sign in to the Apple Business Manager`,
  depTitle3: "Upload your Push Certificate",
  depDescription4: `To complete your setup, please upload the signed token that you downloaded from Apple to Trio.`,
  vppTitle1: `Setting up VPP for your company`,
  vppDescription1: `Set up the VPP (Volume Purchase Program) to purchase applications from your Apple Business Manager in bulk.`,
  vppTitle2: `Sign in to Apple Business/School Manager`,
  vppDescription2: `Sign in to Apple Business Manager using your business Apple ID credentials and download your VPP token.`,
  vppTitle3: "Upload Location Token",
  vppDescription3: `To complete your setup, please upload the token that you downloaded from Apple to Trio.`,
  dragYourFile: "Drag and drop, or click to ",
  deleteVPPConfirmation: `Are you sure? By Deleting this Token you can no longer manage your Apple
  Business Applications (VPPs)!`,
  deleteDEPConfirmation: `Are you sure? By Deleting this Token you can no longer enroll devices
  with zero-touch experience!`,
  deleteApnTitle: `Delete APN’s Certificate?`,
  deleteApnDescription1: `Deleting your APNs certificate will immediately stop all push notifications and remote device management for Apple devices enrolled under this certificate.`,
  deleteApnDescription2: `All Your Enrolled Devices & VPP’s Apps will no longer be manageable!`,
  deviceEnrolled: `Devices enrolled`,
  deviceEnrolledValidation: `To confirm, type the number of enrolled Apple devices using this certificate:`,
  inputDeviceNumbers: "Enter device numbers",
  appleConfigurations: "Apple’s Configurations",
  passwordLength: "Password length",
  saveChanges: "Save Changes",
  minimumPasswordLength: "Set a minimum password length",
  howManyCharacters: "Character length",
  complexity: "Complexity",
  policiesThatAreMandatoryToPasswords:
    "Set mandatory complexities for all passwords.",
  lowercase: "Lowercase",
  uppercase: "Uppercase",
  numeral: "Number",
  specialCharacter: "Special character",
  forcePasswordChange: "Mandatory password expiration",
  showHowLongUserCanUseAPassword:
    "Determine how long until the users have to change their passwords.",
  passwordExpirationData: "Password expiration date",
  reusePasswords: "Reuse passwords",
  howLongBeforeExpirationResetIsRequired:
    "How long before expiration reset password is required",
  days: "days",
  lockout: "Limited login attempts",
  lockoutDescription: `Limit the number of login attempts by users before the device gets locked.`,
  loggingAttemps: "Login attempts",
  passwordRecoveryEmail: "Password recovery email",
  recoveryEmailDescription: `Allow users to reset their passwords using <br /> an email
  address other than their organization's.`,
  mfaForceActivation: "Email Multi-Factor Authentication",
  mfaForceActivationDescription:
    "All users of the Trio admin portal must activate MFA.",
  vppSetup: "VPP Setup",
  deleteApnCertificate: "Delete APNs Certificate",
  deleteDepToken: "Delete Apple Device Enrollment (DEP) Token",
  securitySubtitle:
    "The Security settings allow admins to enforce MFA for users, manage profiles and unenroller PINs, and control other access-related protections.",
  deleteVppToken: "Delete Apple App & Books (VPP) Token",
  apnDescription:
    "APNs is a requirement for enrolling your Apple devices into Trio and fully managing them.",
  apnDescriptionConnected:
    "Your certificate is active and devices can be managed remotely.",
  apnCertificate: "Apple Push Notification Service (APN)",
  appleId: "Apple ID",
  appleIdUsed: "Apple ID Used",
  expirationDate: "Expiration Date",
  serverTokenExpiration: "Server Token Expiration",
  tokenExpiration: "Token Expiration",
  certificateExpiration: "Certificate Expiration",
  certificateUID: "Certificate UID",
  devicesLinked: "Devices Linked",
  totalLicensesAvailable: "Total Licenses Available",
  disconnect: "Disconnect",
  renew: "Renew",
  depDescription:
    "Automatically enroll into Trio when they are first unboxed and configure company-owned Apple devices.",
  depDescriptionConnected:
    "DEP is connected. Devices assigned in ABM/ASM will be auto-enrolled.",
  depToken: "Automated Device Enrollment (DEP)",
  onboardSetupConfiguration: "Onboard setup configuraion",
  companyName: "Company Name",
  vppDescription: "Buy and distribute apps and books to Apple devices.",
  vppDescriptionConnected:
    "DEP is connected. Devices assigned in ABM/ASM will be auto-enrolled.",
  vppToken: "App & Book Management (VPP)",
  adminListDetail: `Assign different roles to your users to provide them with various access levels to the web panel.`,
  adminListAndSetting: "Admin's list & settings",
  searchInEmployees: "Search in Users",
  addNewAdmin: "Add new admin",
  watchManageAdmin: "Watch how to manage admins in Trio",
  all: "All",
  owner: "Owner",
  superAdmin: "Super admin",
  it: "IT",
  hr: "HR",
  updateRole: "Update role",
  updateAdminRole: "Update admin's role",
  chooseAdminRole: "Choose admin's role",
  department: "Autopilot",
  from: "From",
  revokeAdminAccess: "Revoke Admin’s Accesses?",
  revokeConfirmBody:
    "Are you sure? By revoking admin accesses, admins turn to regular user.",
  revokeAccess: "Revoke Access",
  name: "Name",
  role: "Role",
  editAccesses: "Update admin role",
  revokeAllAccesses: "Revoke admin rights",
  offboardEmployee: "Offboard user",
  deleteTrcValidation:
    "Deleting this link will remove Trio's access.  Are you sure you want to proceed?",
  addTermAndCondition: "Add Terms & Condition",
  termAndConditionsDescription: "Input your terms & conditions link",
  theFieldIsRequired: "This field is required",
  step: "Step",
  emailIsInvalid: "Email is invalid",
  nothingFound: "Nothing found",
  deviceManagement: "Device Management",
  profileManagement: "Profile Management",
  applicationManagement: "Application Management",
  showLess: "Show less",
  showAll: "Show all",
  accessDescription: "Access to managing devices, set policies & m...",
  accesses: "Access to",
  deleteDepDescription1: `Removing this DEP token will stop syncing with Apple Business Manager and prevent automatic enrollment for all linked devices.`,
  deleteDepDescription2: `All Your Enrolled Devices & VPP’s Apps will no longer be manageable!`,
  deleteVppDescription1: `Are you sure? By Deleting this Certificate you no longer can managed
  your enrolled devices!`,
  deleteVppDescription2: `All Your Enrolled Devices & VPP’s Apps will no longer be manageable!`,
  editCompanyName: "Edit",
  organization_name: "Organization name",
  companyNameChanged: "Company Name Changed",
  companyPhoneNumberChanged: "The company's phone number has been updated",
  apnSecondStepDescription:
    "Next, log in to the Apple portal using the Apple ID and upload the certificate for your organization.",
  yourLink: "Your link",
  organizationSubtitle: `Enter your company’s information, such as logo, office location, and contact details, for future use.`,
  mdmSetupSubtitle: `MDM Setup allows admins to configure core MDM settings, including APNs certificates, VPP and DEP tokens, and other enrollment-related configurations.`,
  profile_removal_password: "Profile removal password",
  password_needed_want_unenroll_devices:
    "Set a password that is needed when unenrolling devices.",
  // Update
  organizationInformation: "Organization information",
  LogintotheAppleportal: "Upload CSR and renew certificate",
  LogintotheAppleBusinessManager: "Log in to the Apple Business Manager",
  logtheAppleBusinessPortal:
    "Log in to Apple Business Manager, add a new MDM server, and upload the public key. Then, download the server token (.p7m file).",
  show: "Show",
  BusinessappleID: "Business Apple ID",
  deletemanualpolicies: "Delete manual policies?",
  deletemanualTrcValidation:
    "Deleting this section removes Trio's access to the manual terms and conditions. Are you sure you want to proceed?",
  renewABMservertoken: "Renew Automated Device Enrollment (DEP) Token",
  renewABMservertokendescription:
    "Renew DEP server token to ensure continued seamless device enrollment.",
  updateyourDEPservertoken:
    "Update your DEP server token to keep enrolling devices from Apple Business Manager.",
  renerAPNrPushCertificate: "Renew Apple Push Notification Service (APNs)",
  renewAPNspushcertificatedescription:
    "Renew APNs push certificate to ensure maximum security and communication.",
  reneryourAPNscertificate:
    "Renew your APNs certificate to ensure uninterrupted device communication.",
  APNsforyourcompany:
    "Follow the steps below to set up Apple's Push Notifications (APNs) for your company.",
  DEPinApplebusinessmanager:
    "Follow the steps below to set up the Device Enrollment Program (DEP) in Apple business manager (ABM) to auto-enroll devices in your panel with your customized activation mode.",
  renewVPPservertoken: "Renew Volume Purchase Program (VPP)",
  renewVPPtokentoensureuninterrupted:
    "Renew VPP token to ensure uninterrupted app management for your devices.",
  updateyourVPPservertoken:
    "Update your VPP server token for continued access to Volume Purchase Program features.",
  followthestepsbelowtosetupVPP:
    "Follow the steps below to set up VPP (Volume Purchase Program) and easily purchase and distribute in bulk for your business devices. Keep in mind, you need Apple Business Manager (ABM).",
  configureAndroidEMM: "Configure Android EMM",
  googleAndroidEnterprise: "Google Android Enterprise",
  googleAndroidEnterpriseDescription:
    "For setting up Android Enterprise to manage Android devices, youʼll need to register Trio as your Enterprise Mobility Management (EMM) provider with Google.",
  googleSelfManagedAndroidEnterprise: "Self Managed Google Android Enterprise",
  googleSelfManagedAndroidEnterpriseDescription:
    "Provides flexibility for customers who prefer control over their configuration. Customers can enable Android Enterprise by filling out a form, providing their own service account details, and managing EMM APIs independently.",

  edtiInfo: "Edit info",
  enterpriseDisconnectTitle: "Are you sure want to disconnect?",
  enterpriseDisconnectDescription:
    "Clearing the EMM registration will remove all management capabilities, including profiles, apps, and corporate data from the device. This action is irreversible. Do you want to proceed?",
  androidEmmTermsAndConditionTitle: "Terms and conditions provided by {{name}}",
  officerName: "Officer name",
  officerEmail: "Officer email",
  officerPhone: "Officer phone",
  emmEmailTitle: "Email",
  phone: "Phone",
  editTermsAndConditionTitle: "Edit terms and conditions",
  editTermsAndConditionDrawerTitle: "Edit Android enterprise info",
  editTermsAndConditionFormTitle: "Edit Google enterprise account setup",
  editForm: {
    dataProtectionOfficerName: "Officer name",
    dataProtectionOfficerEmail: "Officer email",
    dataProtectionOfficerPhone: "Officer phone",
  },
  changesSaved: "Changes saved",
  appLibrary: "Go to Trio Software Management",
  addApplicationsABM: "Add Applications to ABM",
  addApplication: "Add Application",
  addApps: "Add apps",
  addApplicationmanage: "How to Manage VPP Software",
  followthissteps:
    "Follow this steps to access Trio MDM to manage your license -free or perineum applications - with ABM dashboard.",
  addApplicationsABMDescription:
    "Go to ABM and add both license-free and premium applications. Ensure that all apps you want to manage are included in this panel",
  addApplicationsApplicationLibrary:
    "Add Applications to Application Library in Trio",
  addApplicationsApplicationLibraryDescription:
    "Then, add all your Apple applications to the Application Library. for macOS, iOS and iPad OS from app store.",
  ANDROID: "Android",
  IOS: "iPhones & iPads",
  MAC: "Macs",
  WINDOWS: "Windows",

  drawerGoogleSelfManagedAndroidEnterprise:
    "Self Managed Google Android Enterprise",
  drawerGoogleSelfManagedAndroidEnterpriseDescription:
    "Offers flexibility for customers to control their configuration by enabling Android Enterprise, filling out a form, providing service account details, and managing EMM APIs independently.",

  completeForm: "Complete the form to link Trio with your Google account",
  provideInformation: "Provide the required information to complete the setup.",
  googleWebOAuth: "Google Web OAuth",
  googleWebOAuthDescription: "Provide JSON file for Google Web OAuth",
  serviceAccount: "Service Account",
  pasteYourJSONFileHere: "Paste your JSON file here",
  serviceAccountDescription: "Provide JSON file for service account",
  enableGooglePlayEmmAPI: "Enable Google Play EMM API",
  enableGooglePlayEmmAPIDescription:
    "Allows you to integrate with Google Play for managing app distribution, approvals, and configuration on Android devices.",
  enableAndroidEnterpriseAPI: "Enable Android Enterprise API",
  enableAndroidEnterpriseAPIDescription:
    "Enables the management of Android devices using advanced Android Enterprise features.",
  agreeAndConsent:
    "Agree and consent to having the above details stored in the Trio database.",
  delete_warning: "This action cannot be undone.",
  selfManagedGuide: "Self-Managed Configuration Guide",
  trioHelpCenter: "Trio help center",
  RemainTitle: "Please Remain on This Page Until Completion",
  ok: "OK",
  closeReset: "Close and Reset",
  Remaindes:
    "Closing the tab will lost all the steps and you should start from the beginning, please remain until you finish the process.",
};
